import RoomLobby from '../components/rooms/RoomLobby';

function RoomLobbyPage() {
  return <RoomLobby />;
}

export default RoomLobbyPage;
